<script>
  import { onMount, onDestroy, getContext } from "svelte";
  import Percepto from './percepto'
  import { addOverlay, removeOverlay, getMap } from "../map";
	import PerceptoMarker from "../components/PerceptoMarker.svelte";

  const flight = getContext("flight").get()
  let percepto

  let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("Percepto", layer, flight.overlay);
		percepto = flight.getHandler(Percepto)
		layer.addTo(getMap())
	});
	onDestroy(() => {
		removeOverlay(layer, flight.overlay)
		layer.removeFrom(getMap())
		flight.releaseHandler(Percepto)
	})
</script>

{#if $percepto}
{#each Object.values($percepto) as perceptoHit (perceptoHit[0].droneId)}
  <PerceptoMarker info={perceptoHit} {layer} />
{/each}
{/if}